export const GET_GROUP = 'GET_GROUP';

export default {
  GET_GROUP,
};



// WEBPACK FOOTER //
// ./src/store/modules/group/mutation-types.js